import { useState } from "react";
import { Button } from "@/components/ui/button";
import { FullPageLoader } from "@common/components/Loading/FullPageLoading";
import { profileValidator } from "./EditProfile.model";

interface Props {
  onClose: () => void;
}

export const EditProfileForm = ({ onClose }: Props) => {
  const [ready] = useState(false);

  const handleSubmit = async () => {
    if (ready) {
      try {
        const formData = new FormData();
        const parsedValues = profileValidator.parse(formData);
        console.log(parsedValues);
        onClose();
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const isLoading = null;

  if (isLoading) {
    return <FullPageLoader />;
  }

  return (
    <div className="flex max-h-full flex-col space-y-4 overflow-hidden">
      <Button
        type="button"
        onClick={handleSubmit}
        className="w-full"
        id="submit-button"
      >
        Submit
      </Button>
    </div>
  );
};
